import ConfirmationModal from "@/components/display/ConfirmationModal";
import constants from "@/utils/constants";
import router from "@/router";
import store from "@/store";

const statusMap = {
  closed: "danger",
  Closed: "danger",
  open: "success",
  Open: "success",
  "Pending Welcome Email": "warning",
};

const confirmCloseTicket = (ticket) =>
  store.dispatch("tickets/close", { id: ticket.id }).then(() => {
    goToTicket(ticket.id);
    store.dispatch("toasts/addToast", {
      variant: "info",
      message: `Closing ticket ${ticket.subject}.`,
    });
  });

export const closeTicket = (ticket) =>
  store.dispatch("modals/open", {
    template: ConfirmationModal,
    data: {
      confirm: confirmCloseTicket.bind(null, ticket),
      errorMessage: "There was an error and the ticket could not be closed.",
      message: "Are you sure you wish to close this ticket?",
      title: "Close Ticket",
    },
  });

const confirmOpenTicket = (ticket) =>
  store.dispatch("tickets/open", { id: ticket.id }).then(() => {
    goToTicket(ticket.id);
    store.dispatch("toasts/addToast", {
      variant: "info",
      message: `Opening ticket ${ticket.subject}.`,
    });
  });

export const openTicket = (ticket) =>
  store.dispatch("modals/open", {
    template: ConfirmationModal,
    data: {
      confirm: confirmOpenTicket.bind(null, ticket),
      errorMessage: "There was an error and the ticket could not be closed.",
      message: "Are you sure you wish to reopen this ticket?",
      title: "Reopen Ticket",
    },
  });

export const goToTicket = (id) => {
  if (router.currentRoute.value.name !== constants.ROUTES.TICKET) {
    router.push({ name: constants.ROUTES.TICKET, params: { id } });
  }
};

export const getTicketStatusColor = (ticket) => statusMap[ticket?.status];
